"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeZones = exports.LoLang = void 0;
var LoLang;
(function (LoLang) {
    LoLang["EN"] = "EN";
    LoLang["KO"] = "KO";
    LoLang["JA"] = "JA";
    LoLang["ZH"] = "ZH";
})(LoLang = exports.LoLang || (exports.LoLang = {}));
exports.TimeZones = [{ key: "Asia/Seoul", offset: 9 * 60 }];
//# sourceMappingURL=common.js.map